export default function(value){
    let hours = Math.floor(value / 60);
    let minutes = Math.round(value - (hours * 60));

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}:${minutes}`;
}